import axios from 'axios'
import { getUserURL } from '../api'

const pwdURL = getUserURL()+"/v1/password-reset"
export const sendPwdResetReq = (email) => axios.get(pwdURL + `?email=${encodeURIComponent(email)}`);

export const valCode = code => axios.post(pwdURL+"/code",{code: code});

export const updatePwd = (code, password) => axios.post(pwdURL, {code:code,password: password});
